export default {
    id: 'golden',
    colors: ['#880132', '#FDEC4D'],
};
